import { render, staticRenderFns } from "./PartitionObjectsPage.vue?vue&type=template&id=75f6f2a8&"
import script from "./PartitionObjectsPage.vue?vue&type=script&lang=js&"
export * from "./PartitionObjectsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports